import axios, { AxiosRequestConfig } from 'axios'
import {
  CreateCrmRuleRequestDto,
  CreateCrmRuleResponseDto,
  GetCrmRulesRequestDto,
  GetCrmRulesResponseDto,
  UpdateCrmRuleRequestDto,
  UpdateCrmRuleResponseDto,
} from '@sparling/financial-common'

const BASE_URL = `${process.env.REACT_APP_SERVER_URL}/crm/rules/risk-score`

export const createRule = async (
  { token, ...data }: CreateCrmRuleRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<CreateCrmRuleResponseDto> => {
  const response = await axios.post<CreateCrmRuleResponseDto>(`${BASE_URL}/create`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
  return response.data
}

export const getRules = async (
  { token, ...params }: GetCrmRulesRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetCrmRulesResponseDto> => {
  const response = await axios.get<GetCrmRulesResponseDto>(BASE_URL, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
  return response.data
}

export const getRule = async (
  { token, id }: { token: string; id: number },
  options: AxiosRequestConfig = {},
): Promise<CreateCrmRuleResponseDto> => {
  const response = await axios.get<CreateCrmRuleResponseDto>(`${BASE_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
  return response.data
}

export const updateRule = async (
  payload: UpdateCrmRuleRequestDto & { token: string; id: number },
  options: AxiosRequestConfig = {},
): Promise<UpdateCrmRuleResponseDto> => {
  const { token, id } = payload
  const response = await axios.patch<UpdateCrmRuleResponseDto>(`${BASE_URL}/${id}`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
  return response.data
}

export const deleteRule = async (
  { token, id }: { token: string; id: number },
  options: AxiosRequestConfig = {},
): Promise<void> => {
  await axios.delete(`${BASE_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
}
